export
const name: string = "SsaoRender";

export
const preproc: string = ``;

export
const declaration: string = `
    const int kernel_size = 16;

    uniform sampler2D u_positions;
    uniform sampler2D u_normals;
    uniform sampler2D u_noise;

    uniform float u_radius;
    uniform float u_bias;

    uniform mat4 u_projection;
    uniform vec3 u_samples[kernel_size];
    uniform vec2 u_noise_scale;
    uniform vec2 u_buffer_size;

    uniform vec4 u_view;
    uniform mat4 u_view_matrix;
`;

export
const varyings: string = `
    varying vec2 v_texcoord;
    varying mat3 v_view_normal_matrix;
`;

export
const implementation: string = `

    /**
     * Convert <0, 1> to <Offset, Size>
     */
    vec2 toViewCoords(in vec2 txCoords, in vec4 viewSize) {
        return txCoords * viewSize.zw + viewSize.xy;
    }

    void main(void)
    {
        // Multiply texcoord by viewport size
        vec2 texcoord = toViewCoords(v_texcoord, u_view);

        vec3 fragPos = (vec4(texture2D(u_positions, texcoord).xyz, 1.0)).xyz;

        vec3 normalWorldSpace = texture2D(u_normals, texcoord).xyz;
        vec3 normal = normalWorldSpace;//normalize(  * normalWorldSpace);

        vec3 randomVec = normalize(texture2D(u_noise,  texcoord * u_noise_scale ).xyz);

        vec3 tangent = normalize(randomVec - normal * dot(randomVec, normal));
        vec3 bitangent = cross(normal, tangent);
        mat3 TBN = mat3(tangent, bitangent, normal);

        float occlusion = 0.0;
        for (int i=0; i<kernel_size; ++i) {
            vec3 item = TBN * u_samples[i];
            item = fragPos + item * u_radius;

            vec4 offset = vec4(item, 1.0);
            offset = u_projection * offset;
            offset.xyz /= offset.w;
            offset.xyz = offset.xyz * 0.5 + 0.5;

            // Multiply by view size
            offset.xy = toViewCoords(offset.xy, u_view);

            float itemDepth = (vec4(texture2D(u_positions, offset.xy).xyz, 1.0)).z;

            float rangeCheck = smoothstep(0.0, 1.0, u_radius / abs(fragPos.z - itemDepth));
            occlusion += (itemDepth >= item.z + u_bias ? 1.0 : 0.0) * rangeCheck;
        }

        occlusion = 1.0 - occlusion / float (kernel_size);
        gl_FragColor = floatToVec4(occlusion);
    }
`;
